import { render, staticRenderFns } from "./DefaultMessageModal.vue?vue&type=template&id=5ebde86e"
import script from "./DefaultMessageModal.vue?vue&type=script&lang=js"
export * from "./DefaultMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports